// NewClientModal.js
import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import clientApi from "../../data/api/clientApi";
import ErrorMessage from "../helpers/ErrorMessage";
import { useLanguage } from "../helpers/LanguageContext";

function NewClientModal({ onClose, onCreated }) {
  const dispatch = useDispatch();
  const { t } = useLanguage();
  const [clientName, setClientName] = useState("");
  const [clientTel, setClientTel] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    if (!clientName || !clientTel || !clientAddress) {
      setError(t("newClientFieldsError"));
      return;
    }

    const newClientData = {
      name: clientName,
      telephone: clientTel,
      address: clientAddress
    };

    try {
      setSaving(true);
      const client = await dispatch(clientApi.createClientApi(newClientData));
      onCreated?.(client);
      onClose();
    } catch (error) {
      setError(t("newClientServerError"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-body">
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formClientName">
          <Form.Label>{t("newClientName")}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t("newClientNamePlaceholder")}
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formClientTel">
          <Form.Label>{t("newClientTel")}</Form.Label>
          <Form.Control
            type="tel"
            placeholder={t("newClientTelPlaceholder")}
            value={clientTel}
            onChange={(e) => setClientTel(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formClientAddress">
          <Form.Label>{t("newClientAddress")}</Form.Label>
          <Form.Control
            type="text"
            placeholder={t("newClientAddressPlaceholder")}
            value={clientAddress}
            onChange={(e) => setClientAddress(e.target.value)}
          />
        </Form.Group>
        {error && <ErrorMessage message={error} />}
        <Button variant="primary" type="submit" disabled={saving}>
          {t("newClientSubmit")}
        </Button>
      </Form>
    </div>
  );
}

export default NewClientModal;
